"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatFooter = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common");
const shared_styles_1 = require("@/stylesheets/shared.styles");
let ChatFooter = class ChatFooter extends lit_1.LitElement {
    render() {
        return (0, lit_1.html) `
      <div class="inner"><slot></slot></div>
    `;
    }
};
ChatFooter.styles = (0, lit_1.css) `
    :host {
      box-sizing: border-box;
      ${shared_styles_1.layerContainerStyles};
      z-index: var(--material-zindex-elevated);
    }

    /* 재질은 ::before 형제 레이어가 소유한다. 조상에 backdrop-filter가 걸리면 prompt-input 안 첨부 popover의 blur가 죽기 때문이다. */
    :host::before {
      background: var(--material-chrome-background-color);
      backdrop-filter: var(--material-chrome-backdrop-filter);
      -webkit-backdrop-filter: var(--material-chrome-backdrop-filter);
      ${shared_styles_1.backgroundLayerStyles};
    }

    /* 화면 전체를 덮는 스크롤 위로 프롬프트 입력이 떠서
         chat-feed가 그 아래로 깔리고 글래스모피즘이 성립한다. */
    .inner {
      display: flex;
      flex-direction: column;
      width: 100%;
      max-width: var(--layout-width-small);
      margin: 0 auto;
      gap: var(--space-3);
      padding: var(--space-4) var(--layout-padding-inline);
      box-sizing: border-box;
    }
  `;
ChatFooter = __decorate([
    (0, decorators_js_1.customElement)('mm-chat-footer')
], ChatFooter);
exports.ChatFooter = ChatFooter;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2hhdC1mb290ZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJjaGF0LWZvb3Rlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSw2QkFBMkM7QUFDM0MscURBQWlEO0FBRWpELCtCQUE0QjtBQUM1QiwrREFBeUY7QUFHbEYsSUFBTSxVQUFVLEdBQWhCLE1BQU0sVUFBVyxTQUFRLGdCQUFVO0lBOEJ4QyxNQUFNO1FBQ0osT0FBTyxJQUFBLFVBQUksRUFBQTs7S0FFVixDQUFBO0lBQ0gsQ0FBQzs7QUFqQ00saUJBQU0sR0FBRyxJQUFBLFNBQUcsRUFBQTs7O1FBR2Isb0NBQW9COzs7Ozs7Ozs7UUFTcEIscUNBQXFCOzs7Ozs7Ozs7Ozs7Ozs7R0FlMUIsQ0FBQTtBQTVCVSxVQUFVO0lBRHRCLElBQUEsNkJBQWEsRUFBQyxnQkFBZ0IsQ0FBQztHQUNuQixVQUFVLENBbUN0QjtBQW5DWSxnQ0FBVSJ9